import React, { FunctionComponent, useEffect, useState } from 'react';
import SaveIcon from '@mui/icons-material/Save';
import CloseIcon from '@mui/icons-material/Close';
import { useParams } from 'react-router-dom';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { MyTextFiled } from '../UI/MyTextField';
import { BackDropDiv } from '../backdrop/BackDropDiv';
import { IApiResult } from '../../interface/IApiResult';
import { IAlertProps } from '../../interface/IAlertProps';
import { formatTestToHtml, getDefaultAlertProps } from '../../utils/utils';
import { API_STATUS_PROBLEM } from '../../constant/constants';
import { AlertSeverityEnum } from '../../enum/AlertSeverityEnum';
import { MyAlert } from '../UI/MyAlert';
import { ContentDto } from '../../dto/ContentDto';
import { TestDto } from '../../dto/TestDto';
import { apiAddTest } from '../../service/apiAddTest';
import { apiGetTest } from '../../service/apiGetTest';

interface Props {
  dto: ContentDto;
  open: boolean;
  onClose: () => void;
}

export const DialogAddTest: FunctionComponent<Props> = ({
  dto,
  open,
  onClose,
}) => {
  const [testDto, setTestDto] = useState<TestDto>({
    test: '',
    formatTest: '',
  });
  const [alertProps, setAlertProps] = useState<IAlertProps>(
    getDefaultAlertProps()
  );
  const [backDrop, setBackDrop] = useState(false);

  const [, setCheckHelper] = useState(false);
  const { section } = useParams();

  const getTest = async () => {
    setBackDrop(true);
    const apiResult: IApiResult = await apiGetTest(section ?? '', dto.route);
    if (apiResult.isSuccess) {
      setTestDto(apiResult.data);
    } else {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
    setBackDrop(false);
  };

  const addTest = async () => {
    setBackDrop(true);
    const apiResult: IApiResult = await apiAddTest(
      section ?? '',
      dto.route,
      dto.keyFormat,
      testDto
    );
    if (apiResult.isSuccess) {
      getTest();
    } else {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
    setBackDrop(false);
  };

  const handleAdd = async () => {
    await addTest();
    setCheckHelper(false);
  };

  useEffect(() => {
    if (open) {
      setTestDto({
        test: '',
        formatTest: '',
      });
      getTest();
      setCheckHelper(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <div>
      <BackDropDiv open={backDrop} />
      <Dialog
        open={open}
        fullWidth
        maxWidth="lg"
        style={{ userSelect: 'none' }}
        PaperProps={{
          sx: { backgroundColor: '#e7ebee', width: '100%', height: '100%' },
        }}
      >
        <MyAlert
          message={alertProps.message}
          severity={alertProps.severity}
          onClose={() => setAlertProps({ ...alertProps, message: '' })}
        />
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography
              style={{
                fontFamily: 'sans-serif',
                fontSize: '16px',
                textAlign: 'left',
                fontWeight: '600',
              }}
              component="text"
            >
              {`${dto.keyFormat} ${dto.name} - Тесты`}
            </Typography>
            <Stack direction="row" spacing={1}>
              {' '}
              <IconButton
                size="medium"
                sx={{ color: '#9c27b0' }}
                onClick={handleAdd}
              >
                <SaveIcon fontSize="medium" />
              </IconButton>
              <IconButton size="medium" onClick={onClose}>
                <CloseIcon fontSize="medium" />
              </IconButton>
            </Stack>
          </Stack>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <Stack padding="10px" spacing={1}>
                <MyTextFiled
                  value={testDto.test.replaceAll('</br>', '\n')}
                  multiLine
                  onChange={(e) =>
                    setTestDto({
                      ...testDto,
                      test: e.target.value.replaceAll('\n', '</br>'),
                    })
                  }
                  size="small"
                  label=""
                />
              </Stack>
            </Grid>
            <Grid item xs={6}>
              <Stack padding="10px" spacing={1}>
                <Typography
                  style={{
                    fontFamily: 'sans-serif',
                    fontSize: '14px',
                    overflow: 'auto',
                    fontWeight: '400',
                    textAlign: 'left',
                    lineHeight: '22px',
                  }}
                  component="html"
                >
                  <div
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                      __html: formatTestToHtml(
                        testDto.test.replaceAll('#**#', '"')
                      ),
                    }}
                  />
                </Typography>
              </Stack>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </div>
  );
};
